import http from '@/utils/http';
/*
查询提醒按钮状态
*/
export const getFavorInfo = (params) => {
    return http({
      url: '/client/sysremind/getFavorInfo',
      method: 'GET',
      params
    });
};
/*
在登录时查询用户是否需要提醒
*/
export const remindEmail = (params) => {
    return http({
      url: '/client/sysremind/remindEmail',
      method: 'GET',
      params
    });
};
  /*
  提交提醒按钮数据
  */
  export const updateFavor = (data) => {
    return http({
      url: '/client/sysremind/updateFavor',
      method: 'POST',
      data: data
    });
  };

/**
 * 查询公告信息
 */
export const getFontMsgApi = (params) => {
  return http({
    url: '/client/fontMesg/getFontMsg',
    method: 'GET',
    params
  });
};

/**
 * 查询小铃铛近 30 天已读历史
 */
export const getReadHistory = (params) => {
  return http({
    url: '/client/sysremind/readHistory',
    method: 'GET',
    params
  });
};

/**
 * 生成兑换码
 */
export const getRedeemCodeApi = (data) => {
  return http({
    url: '/clientb/sysexchange/getRedeemCode',
    method: 'POST',
    params: data
  });
};

/**
 * 兑换流量
 */
export const allocateRedeemCodeGb = (data) => {
  return http({
    url: '/clientb/sysexchange/allocateRedeemCodeGb',
    method: 'POST',
    params: data
  });
};

/**
 * 流量使用统计
 */
export const flowGbFoldApi = (params) => {
  return http({
    url: '/clientb/useflow/flowGbFold',
    method: 'GET',
    params
  });
};

/**
 * 流量使用统计小时
 */
export const flowGbFoldByTimeApi = (params) => {
  return http({
    url: '/clientb/useflow/flowGbFoldBuyTime',
    method: 'GET',
    params
  });
};


/**
 * 使用兑换码兑换流量
 */
export const allocateRedeemCodeGbApi = (data) => {
  return http({
    url: '/clientb/sysexchange/allocateRedeemCodeGb',
    method: 'POST',
    params: data
  });
};
/**
 * 企业流量分配
 */
export const updateDistribute = (data,token) => {
  return http({
    url: '/clientb/syssubuser/firmGbrReturn',
    method: 'POST',
    params: data,
    headers: {
      'Idempotent-Token': token
    }
  });
};
/**
 * 个人基本新增企业流量分配
 */
export const peronGbReturn = (data,token) => {
  return http({
    url: '/clientb/syssubuser/peronGbReturn',
    method: 'POST',
    params: data,
    headers: {
      'Idempotent-Token': token
    }
  });
};


export const getAgencyList = (params) => {
  return http({
    url: '/clientb/sysagency/getAgencyList',
    method: 'GET',
    params
  });
};

/**
 * 企业计划查询兑换日志
 */
export const firmPlanListApi = (params) => {
  return http({
    url: '/clientb/sysexchange/firmPlanList',
    method: 'GET',
    params
  });
};

// 获取轮播图
export const getBannerListApi = () => {
  return http({
    url: '/client/extendphoto/getphotoList',
    method: 'GET'
  });
};

// 获取合作伙伴
export const getPartnterListApi = () => {
  return http({
    url: '/client/partnersphoto/getphotoList',
    method: 'GET'
  });
};

// 记录点击次数
export const recordClickApi = (data) => {
  return http({
    url: 'client/codeSource/saveCount',
    method: 'POST',
    params: data
  });
};
//查询流量明细的表格数据(企业--基本)
export const firmPlanList = (params) => {
    return http({
      url: '/clientb/sysexchange/firmPlanList',
        method: 'GET',
        params
    });
};
  //查询流量明细的表格数据(个人--基本)
export const personalPlanList = (params) => {
    return http({
      url: '/clientb/sysexchange/personalPlanList',
        method: 'GET',
        params
    });
};
 //查询流量明细的表格数据(企业--高级)
export const seniorFirmPlanList = (params) => {
    return http({
      url: '/clienta/sysexchange/firmPlanList',
        method: 'GET',
        params
    });
};
//查询流量明细的表格数据(企业--移动)
export const seniorFirmPlanListC = (params) => {
  return http({
    url: '/clientc/sysexchange/firmPlanList',
    method: 'GET',
    params
  });
};
//查询流量明细的表格数据(企业--数据)
export const seniorFirmPlanListD = (params) => {
  return http({
    url: '/clientd/sysexchange/firmPlanList',
    method: 'GET',
    params
  });
};

  //查询流量明细的表格数据(个人--高级)
export const seniorPersonalPlanList = (params) => {
    return http({
      url: '/clienta/sysexchange/personalPlanList',
        method: 'GET',
        params
    });
};

//查询流量明细的表格数据(个人--移动)
export const seniorPersonalPlanListC = (params) => {
  return http({
    url: '/clientc/sysexchange/personalPlanList',
    method: 'GET',
    params
  });
};
//查询流量明细的表格数据(个人--数据)
export const seniorPersonalPlanListD = (params) => {
  return http({
    url: '/clientd/sysexchange/personalPlanList',
    method: 'GET',
    params
  });
};
//获取铃铛消息列表(01/16新接口)
export const remindContent =(params) => {
    return http({
        url: '/client/sysremind/remindContent',
          method: 'GET',
          params
      });
}
//提交铃铛已读状态(01/16新接口)
export const readContent =(params) => {
    return http({
        url: '/client/sysremind/readContent',
          method: 'GET',
          params
      });
}
